import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

const PRICING_API = `${API_URL}/backoffice/orders`;

async function getAll(params) {
  const response = await axios.get(PRICING_API, { params: params, headers: authHeader() });
  return response.data;
}

async function get(id) {
  const response = await axios.get(PRICING_API + '/' + id, { headers: authHeader() });
  return response.data;
}


export default {
  getAll,
  get,
};